import styled from "styled-components/macro";

export const ResultList = styled.ul`
  width: 100%;
  display: flex;
  border-top: 1px solid #B4B4B4;
    
  @media (max-width: 979px) {
    flex-direction: column;
    border: none;
  }
`

export const ResultItem = styled.li`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 26px 26px;

    &:not(:last-child) {
      border-right: 1px solid rgb(180, 180, 180);

      @media (max-width: 979px) {
        border: none;
      }
    }

    @media (max-width: 979px) {
      padding: 0 26px 12px;
      gap: 6px;
      align-items: center;
    }
`

export const Number  = styled.span`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 80px;
  font-weight: 600;
  line-height: 94%;
  padding-top: 26px;
  
  @media (max-width: 979px) {
    padding-top: 12px;
  }
`

export const Desc = styled.span`
  font-size: 18px;
  line-height: 140%;
  
  @media (max-width: 979px) {
    text-align: center;
  }
`
type TIconProps = {
    src: string;
};

export const Icon = styled.span<TIconProps>`
  width: 45px;
  height: 45px;
  background-image: ${({ src }) => `url(${src})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center;
  margin-top: 26px;

  @media (max-width: 979px) {
    margin-top: 12px;
    background-position: center;
  }
`;
